<template>
  <div class="tm-movable-visual" v-tm-move="moveObj">
    <slot />

    <tm-visual-ghost
      v-if="$data.showGhost"
      :asset="$props.asset"
      :point="$data.ghostPoint"
      :mode="$data.mode"
      :isInside="$data.isInside"
    />
  </div>
</template>
<script>
import app from 'app';
import tmMove from './tmMove';
import moveVisualExternalMixin from './moveVisualExternal';
import tmVisualGhost from '../indicator/tmVisualGhost.vue';
import { TimePoint } from '../../api/grid';
import { VisualGhostMode } from '../../api/model';

export default {
  name: 'tm-movable-visual',
  mixins: [moveVisualExternalMixin],
  directives: { tmMove },
  components: {
    tmVisualGhost,
  },

  props: {
    asset: { type: Object, required: true },
  },

  data() {
    return {
      dragEnabled: !this.$_dragShouldBeDisabled(),
      showGhost: false,
      ghostPoint: new TimePoint(),
      isInside: false,
      mode: VisualGhostMode.DEFAULT,
    };
  },

  watch: {
    '$store.state.story.reDraggableAssets': '$_enableDraggable',
  },

  beforeDestroy() {
    app.off('disable-draggable-asset', this.$_disableDraggable);
  },

  mounted() {
    app.on('disable-draggable-asset', this.$_disableDraggable);

    this.$watchAny(['asset._previewOp'], this.$_assetDataChanged, {
      deep: true,
    });
  },

  methods: {
    $_enableDraggable() {
      this.$data.dragEnabled = true;
    },

    $_disableDraggable({ asset }) {
      if (this.asset.id === asset.id) {
        this.$data.dragEnabled = false;
      }
    },

    /**
     * enable draggable when preview generation finished
     */
    $_assetDataChanged(changedProp, newVal, oldVal) {
      // console.debug(`tmMovableVisual: dragEnabled='${this.$data.dragEnabled}'`, changedProp, oldVal, '->', newVal);
      this.$data.dragEnabled = !this.$_dragShouldBeDisabled();
    },

    $_dragShouldBeDisabled() {
      const previewOp = this.asset._previewOp;
      return _.isDefined(previewOp) && !/done/.test(previewOp);
    },
  },
};
</script>
